// METIS Hub wording — namespace "admin" (en), 1061 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/admin.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const admin: Record<string, string> = {
  "admin.rp.review.sumUnknown": "Of {n} grants to review, usage is not yet verified for {u}. Verified unused grants over 90 days: {d}.",
  "admin.rp.review.unknown": "Usage not yet verified",
  "admin.rp.review.unknownD": "Permissions without verified usage records are not classified as unused.",
  "admin.rp.review.keepExpiry": "Keeping a grant preserves its current permissions and expiry date. Extending it requires a separate grant and approval.",

  "admin.act.role.expiry_deferred": "Last administrator expiry deferred",
  "admin.rp.grant.expiryDeferred": "Expiry deferred to protect the last administrator",
  "admin.pc.title": "Please edit on a PC",
  "admin.pc.roles": "On a phone you can read role summaries and handle approvals. Change the permission table, role assignments and service accounts on a PC.",
  "admin.pc.policy": "On a phone the policy is read-only. Change the ceiling, notice, masking rules, retention and access values on a PC.",
  "admin.pc.cost": "On a phone the price table is read-only. Create new price versions on a PC.",
  "admin.cond.all": "Company-wide",
  "admin.undone": "Undone. The undo was logged too.",
  "admin.snack.relogin": "{n|person|people} will sign in again",
  "admin.noExpiry": "No expiry",
  "admin.daysLeft": "{n|day|days} left",
  "admin.more": "+{n} more",
  "admin.reasonMin": "Write a reason of at least {n} characters.",
  "admin.chars": "{n} chars",
  "admin.days": "{n|day|days}",
  "admin.years": "{n|year|years}",
  "admin.months": "{n|month|months}",
  "admin.min": "{n} min",
  "admin.demoTag": "Mockup only",
  "admin.tech.show": "Technical details",
  "admin.tech.action": "Action code",
  "admin.tech.target": "Target type",
  "admin.tech.ids": "Internal IDs",
  "admin.tech.raw": "Original detail",
  "admin.tech.entry": "Entry ID",
  "admin.tech.setting": "Setting name",
  "admin.tech.value": "Current value",
  "admin.go.support": "Open the support table",
  "admin.go.connect": "Open Connect tools",
  "admin.empty.adm-matrix.w": "The role table is empty.",
  "admin.empty.adm-matrix.n": "Without roles, everyone only has Member access (their own records).",
  "admin.empty.adm-roles-list.w": "No roles yet.",
  "admin.empty.adm-roles-list.n": "The 3 base roles always exist. Copy a preset to make a new role.",
  "admin.empty.adm-rules.w": "Rules couldn’t be loaded.",
  "admin.empty.adm-rules.n": "The server still enforces the same rules.",
  "admin.empty.adm-grant.w": "Nobody to assign roles to.",
  "admin.empty.adm-grant.n": "You can’t assign roles outside your scope.",
  "admin.empty.adm-grants.w": "No roles have been assigned yet.",
  "admin.empty.adm-grants.n": "Everyone still has the Member role.",
  "admin.empty.adm-cap.w": "No company ceiling has been set yet.",
  "admin.empty.adm-cap.n": "Until then, only basic info is kept.",
  "admin.empty.adm-notice.w": "No notice has been published yet.",
  "admin.empty.adm-notice.n": "Nothing is stored until a notice is published and agreed to.",
  "admin.empty.adm-notice-ver.w": "No published versions.",
  "admin.empty.adm-notice-ver.n": "Versions appear here once published.",
  "admin.empty.adm-red.w": "No masking rules.",
  "admin.empty.adm-red.n": "Without rules, secrets in text could be stored as-is.",
  "admin.empty.adm-red-pv.w": "No text to preview.",
  "admin.empty.adm-red-pv.n": "Enter fake values to check the result.",
  "admin.empty.adm-red-paths.w": "No secret path rules.",
  "admin.empty.adm-red-paths.n": "CLI credential files are always blocked.",
  "admin.empty.adm-ret.w": "The retention table is empty.",
  "admin.empty.adm-ret.n": "Defaults apply (text 30 days, usage 180 days).",
  "admin.empty.adm-acc.w": "Access control values couldn’t be loaded.",
  "admin.empty.adm-acc.n": "The flow stays on with defaults (60 min, 10 chars, 10 min).",
  "admin.empty.adm-sg.w": "The small-group minimum couldn’t be loaded.",
  "admin.empty.adm-sg.n": "Groups under 3 are still hidden.",
  "admin.empty.adm-vs.w": "The sort setting couldn’t be loaded.",
  "admin.empty.adm-vs.n": "People are listed by name only.",
  "admin.empty.adm-pol-hist.w": "No policy changes yet.",
  "admin.empty.adm-pol-hist.n": "Each saved change appears here.",
  "admin.empty.adm-integ.w": "No log entries yet.",
  "admin.empty.adm-integ.n": "Entries start with the first sign-in.",
  "admin.empty.adm-grades.w": "No log entries yet.",
  "admin.empty.adm-grades.n": "Once entries exist, each grade keeps its retention.",
  "admin.empty.adm-c1.w": "No records received today.",
  "admin.empty.adm-c1.n": "No records doesn’t mean nobody used AI. Check the connections.",
  "admin.empty.adm-c2.w": "No PC helper information.",
  "admin.empty.adm-c2.n": "It is optional, so it stays empty until turned on.",
  "admin.empty.adm-gap.w": "No gap records.",
  "admin.empty.adm-gap.n": "No gaps doesn’t mean every device sent records.",
  "admin.empty.adm-drop.w": "No dropped records.",
  "admin.empty.adm-drop.n": "If records break the rules, counts by reason appear here.",
  "admin.empty.adm-unk.w": "No unfamiliar names.",
  "admin.empty.adm-unk.n": "Unfamiliar events appear here by name and count only.",
  "admin.empty.adm-ver.w": "No version information.",
  "admin.empty.adm-ver.n": "Versions appear when connected CLIs send records.",
  "admin.empty.adm-health.w": "Server status couldn’t be loaded.",
  "admin.empty.adm-health.n": "Intake runs separately, so collection may still be fine.",
  "admin.empty.adm-kinds.w": "No cost records for these filters.",
  "admin.empty.adm-kinds.n": "No cost records doesn’t mean no AI use; some tools don’t send cost.",
  "admin.empty.adm-price.w": "No price table.",
  "admin.empty.adm-price.n": "Without it, gateway calls get no cost.",
  "admin.empty.adm-budget.w": "The budget module is off.",
  "admin.empty.adm-budget.n": "It is a phase-2 optional module; no limits until it is on.",
  "admin.roles.desc": "{r|role|roles} · {k} permission keys in 6 groups · {p} pending",
  "admin.roles.copy": "Copy a role",
  "admin.roles.new": "New role",
  "admin.roles.tabs": "Roles & permissions views",
  "admin.roles.tab.matrix": "Permissions by role",
  "admin.roles.tab.grant": "Assign roles",
  "admin.roles.tab.approvals": "Pending approvals",
  "admin.roles.tab.service": "Service accounts",
  "admin.roles.kpi.roles": "Roles",
  "admin.roles.kpi.rolesHint": "Base {b} · preset {p} · custom {c}",
  "admin.roles.kpi.text": "Roles that open others’ text",
  "admin.roles.kpi.textHint": "All go through the fixed access flow",
  "admin.roles.kpi.pending": "Pending approval",
  "admin.roles.kpi.pendingHint": "Requester and approver must differ",
  "admin.roles.kpi.expiry": "Grants that need an expiry",
  "admin.roles.kpi.expiryHint": "{n} without an expiry",
  "admin.roles.kpi.expiryOk": "All have an expiry",
  "admin.roles.corner": "Permission",
  "admin.roles.kind.base": "Base · read-only",
  "admin.roles.people": "{n|person|people}",
  "admin.roles.everyone": "Everyone",
  "admin.roles.nobody": "Nobody has it yet",
  "admin.roles.dual": "2P",
  "admin.roles.cell.press": "press to change",
  "admin.roles.cell.pending": "Raise to {to} is waiting for approval ({id})",
  "admin.roles.cell.selfNo": "You can’t edit a role you hold (no self-escalation)",
  "admin.roles.matrix.q": "What can each role see?",
  "admin.roles.matrix.tech": "35 permission keys × scope (off · self · team · all) · folded into 6 groups",
  "admin.roles.matrix.sum": "{n} of {r} roles can open others’ question and answer text ({names}).",
  "admin.roles.matrix.expand": "Expand all",
  "admin.roles.matrix.collapse": "Collapse all",
  "admin.roles.matrix.readonly": "Only company-wide role managers edit role definitions. You can only assign and remove roles for people in {teams}.",
  "admin.roles.matrix.src": "Last changed {date} · {who}",
  "admin.roles.legend.lock": "Base roles are read-only (copy one to edit)",
  "admin.roles.legend.team": "Team = the teams set when the role is assigned. Your own team isn’t added automatically.",
  "admin.roles.legend.pend": "Waiting for approval",
  "admin.roles.pop.kicker": "{role} role",
  "admin.roles.pop.scope": "Scope",
  "admin.roles.pop.holders": "{n|person has|people have} this role and will sign in again after a change.",
  "admin.roles.pop.dual": "Raising needs two-person approval. Once approved, the notice section “Who can view” changes too.",
  "admin.roles.pop.exceeds": "You can’t give a wider scope than you have",
  "admin.roles.pop.pending": "A request ({id}) to raise this to {to} is already waiting. Handle it in Pending approvals first.",
  "admin.roles.changed": "Changed {role} · {perm} to {to}",
  "admin.roles.list.q": "Which roles exist, and who has them?",
  "admin.roles.list.tech": "Base 3 · presets 5 · custom · widest scope per group",
  "admin.roles.list.sum": "{n|person has|people have} a role besides Member.",
  "admin.roles.based": "Copy of {base}",
  "admin.roles.mfa": "MFA required",
  "admin.roles.pledge": "Prohibited-use pledge",
  "admin.roles.preview": "Preview",
  "admin.roles.copyThis": "Copy",
  "admin.roles.delete": "Delete",
  "admin.roles.deleteTitle": "Delete this role?",
  "admin.roles.deleteBody": "Deletes the role “{role}”. Only possible when nobody has it and nothing is pending.",
  "admin.roles.deleted": "Deleted the role “{role}”",
  "admin.rules.q": "What rules apply to permission changes?",
  "admin.rules.tech": "Delegation rules · checked by the server on every change",
  "admin.rules.sum": "Changes that break any of these 7 rules are blocked, and the block is logged.",
  "admin.rules.1": "The 3 base roles (Admin, Manager, Member) are read-only. Copy one to edit.",
  "admin.rules.2": "You can’t assign roles to yourself or edit a role you hold (no self-escalation).",
  "admin.rules.3": "You can only give what you have (key, scope and team).",
  "admin.rules.4": "You can’t manage people with more permissions than you.",
  "admin.rules.5": "The last admin can’t be demoted or suspended.",
  "admin.rules.6": "Raising text, name or export permissions needs two-person approval and updates the notice section “Who can view”.",
  "admin.rules.7": "After a change, the affected people sign in again.",
  "admin.dual.title": "Two-person approval needed",
  "admin.dual.kicker": "Text, name or export permissions increase",
  "admin.dual.what": "Change",
  "admin.dual.p1": "The requester and approver must differ. A content reviewer or another admin with two-person approval approves it.",
  "admin.dual.p2": "Once approved, the notice section “Who can view” changes and a new draft version appears.",
  "admin.dual.p3": "When applied, the affected people sign in again.",
  "admin.dual.reason": "Reason (10+ characters)",
  "admin.dual.reasonPh": "e.g. Need teammates’ question text during the incident (2 weeks)",
  "admin.dual.send": "Send for approval",
  "admin.dual.sent": "Sent for approval ({id}). See Pending approvals.",
  "admin.roleDlg.kicker": "Custom role",
  "admin.roleDlg.copyTitle": "Copy a role",
  "admin.roleDlg.newTitle": "New role",
  "admin.roleDlg.base": "Based on",
  "admin.roleDlg.name": "Name",
  "admin.roleDlg.namePh": "e.g. Security investigator",
  "admin.roleDlg.desc": "Description (optional)",
  "admin.roleDlg.hint": "A new role copies the base role’s permissions. Edit cells in the table afterwards. Nobody has it yet, so nobody sees more right now.",
  "admin.roleDlg.basePerms": "Base role scopes by group",
  "admin.roleDlg.create": "Create",
  "admin.roleDlg.errName": "Enter a name of 2–20 characters.",
  "admin.roleDlg.errDup": "A role with this name already exists.",
  "admin.roleDlg.created": "Created the role “{name}”",
  "admin.preview.kicker": "What this role sees",
  "admin.preview.title": "Preview: {role}",
  "admin.preview.kind": "Kind",
  "admin.preview.holders": "Held by",
  "admin.preview.scopes": "View scope options",
  "admin.preview.checks": "Sign-in checks",
  "admin.preview.checksNone": "No extra checks",
  "admin.preview.menus": "{n|menu|menus} shown",
  "admin.preview.bundles": "Widest scope per group",
  "admin.preview.lock": "Opening someone else’s text looks like this",
  "admin.preview.lockFlow": "Opens only after a reason, re-sign-in and a per-conversation grant. Each view is shown to the person.",
  "admin.preview.lockNone": "This role can’t open others’ question and answer text.",
  "admin.preview.switch": "Switch to this role",
  "admin.preview.switchNote": "Mockup only. Come back from the user menu › Switch role.",
  "admin.preview.custom": "Custom roles can’t be switched to in the mockup. Check the menus and scopes above.",
  "admin.preview.current": "You are viewing as this role now.",
  "admin.grant.q": "Who gets which role?",
  "admin.grant.tech": "Find a person → role · teams · expiry · reason",
  "admin.grant.sum": "You can assign roles to {n} people in {scope}.",
  "admin.grant.s1": "Person",
  "admin.grant.s2": "Role",
  "admin.grant.s3": "Teams",
  "admin.grant.s3m": "Teams to manage",
  "admin.grant.s4": "Expiry",
  "admin.grant.s5": "Reason",
  "admin.grant.search": "Search by name or team",
  "admin.grant.pickLabel": "Person to assign",
  "admin.grant.noMatch": "No one matches.",
  "admin.grant.self": "Not yourself",
  "admin.grant.more": "Has more permissions than you",
  "admin.grant.rolePh": "Choose a role",
  "admin.grant.roleExceeds": "wider than yours",
  "admin.grant.roleHas": "already has it",
  "admin.grant.teamHint": "“Team” permissions reach only the teams picked here.",
  "admin.grant.noTeam": "This role has no team-scoped permissions.",
  "admin.grant.required": "Required",
  "admin.grant.expHint": "Roles that see question/answer text or work details for a team or everyone need an expiry.",
  "admin.grant.expOptional": "Leave empty for no expiry. You’ll be told if it goes unused for 90 days.",
  "admin.grant.reasonPh": "e.g. Assigned as Data team manager",
  "admin.grant.effect": "What changes",
  "admin.grant.effectPick": "Pick a person and a role to see the new permissions.",
  "admin.grant.effectNone": "No new permissions — they already have these.",
  "admin.grant.effectNew": "{n|new permission|new permissions}",
  "admin.grant.effectDual": "Applied only after two-person approval.",
  "admin.grant.effectRelogin": "They will sign in again.",
  "admin.grant.submit": "Assign role",
  "admin.grant.submitDual": "Send for approval",
  "admin.grant.reset": "Start over",
  "admin.grant.errPerson": "Pick a person.",
  "admin.grant.errRole": "Choose a role.",
  "admin.grant.errTeam": "Pick at least one team.",
  "admin.grant.errExp": "This role needs an expiry (from tomorrow).",
  "admin.grant.errDate": "Pick an expiry from tomorrow.",
  "admin.grant.errReason": "Write a reason of at least 5 characters.",
  "admin.grant.errDup": "The same role and teams are already assigned.",
  "admin.grant.done": "Gave the “{role}” role to {who}",
  "admin.grant.pcOnly": "Assign roles on a PC. On a phone you only see who has which role.",
  "admin.grants.q": "Who has which role?",
  "admin.grants.tech": "Role grants · teams · expiry · granted and approved by",
  "admin.grants.sum": "{e} of {n} grants have an expiry.",
  "admin.grants.member": "Everyone also has the Member role. It can’t be removed; suspend the account instead.",
  "admin.grants.col.person": "Person",
  "admin.grants.col.role": "Role",
  "admin.grants.col.teams": "Teams",
  "admin.grants.col.expires": "Expires",
  "admin.grants.col.granted": "Granted",
  "admin.grants.col.approved": "Approved by",
  "admin.grants.col.act": "Manage",
  "admin.grants.allScope": "Company-wide",
  "admin.grants.needExpiry": "Set an expiry",
  "admin.grants.soon": "Expires in {n} days",
  "admin.grants.search": "Search people or roles",
  "admin.grants.empty": "No grants match.",
  "admin.grants.revoke": "Remove",
  "admin.grants.revokeTitle": "Remove this role?",
  "admin.grants.revokeBody": "Removes “{role}” from {who}. They will sign in again, and it is logged.",
  "admin.grants.revoked": "Removed “{role}” from {who}",
  "admin.grants.lastAdmin": "The last admin can’t be removed",
  "admin.grants.selfNo": "You can’t remove your own role",
  "admin.grants.moreNo": "Has more permissions than you",
  "admin.apr.q": "Any requests waiting for approval?",
  "admin.apr.tech": "Two-person approval · request → approve → apply",
  "admin.apr.sum": "{n|request is|requests are} waiting.",
  "admin.apr.sumNone": "No requests are waiting.",
  "admin.apr.emptyNot": "Only changes that raise text, name or export permissions come here.",
  "admin.apr.target": "Give {who} “{perm}” ({scope})",
  "admin.apr.viaRole": "via the {role} role",
  "admin.apr.targetRole": "“{perm}” in the {role} role: {from} → {to}",
  "admin.apr.targetCase": "Start investigation {id} · {n|person|people}",
  "admin.apr.targetGrant": "Give {who} the “{role}” role",
  "admin.apr.targetReplace": "Change {who}’s roles to “{role}”",
  "admin.apr.replaceHint": "Approval keeps the member role, revokes every other existing role, and applies the selected role.",
  "admin.apr.meta": "{id} · requested by {req} · {date} · until {until}",
  "admin.apr.sign": "Approval steps",
  "admin.apr.step.req": "Request",
  "admin.apr.step.ok": "Approve",
  "admin.apr.step.apply": "Apply",
  "admin.apr.approverHint": "Content reviewer or another admin",
  "admin.apr.applyHint": "Affected people sign in again",
  "admin.apr.applied": "Applied",
  "admin.apr.notice": "Notice changes",
  "admin.apr.approve": "Approve",
  "admin.apr.reject": "Reject",
  "admin.apr.withdraw": "Withdraw",
  "admin.apr.selfNo": "Requesters can’t approve their own request",
  "admin.apr.sole": "No one but the requester can approve this, so you may approve it yourself. It is recorded as a sole approval; the two-person rule returns once another approver exists.",
  "admin.apr.noPerm": "Someone with two-person approval approves this",
  "admin.apr.tryReviewer": "Try approving as the content reviewer",
  "admin.apr.tryNote": "Approve it from the “Any access work to handle?” card on Home; it is applied here once approved.",
  "admin.apr.approveTitle": "Approve this request?",
  "admin.apr.approveBody": "Approving applies it right away and the affected people sign in again. The approval is logged.",
  "admin.apr.rejectTitle": "Reject this request?",
  "admin.apr.rejectReason": "Reason for rejecting (5+ characters)",
  "admin.apr.memo": "Note (optional)",
  "admin.apr.approved": "Approved and applied. Logged.",
  "admin.apr.rejected": "Rejected. Logged.",
  "admin.apr.withdrawn": "Request withdrawn. Logged.",
  "admin.apr.status.pending": "Pending",
  "admin.apr.status.approved": "Approved",
  "admin.apr.status.rejected": "Rejected",
  "admin.apr.status.withdrawn": "Withdrawn",
  "admin.case.q": "Any investigations in progress?",
  "admin.case.tech": "Investigations that open several people’s text · targets · period · two-person approval",
  "admin.case.sum": "{a} of {n|investigation is|investigations are} in progress.",
  "admin.case.sumNone": "No investigations.",
  "admin.case.emptyNot": "Repeatedly opening several people’s text is only allowed through an investigation.",
  "admin.case.targets": "Targets",
  "admin.case.period": "Period",
  "admin.case.views": "{n|view|views}",
  "admin.case.notify": "Owner notice: immediate (no deferral)",
  "admin.case.notifyLabel": "Owner notice",
  "admin.case.notifyNow": "Immediate (no deferral)",
  "admin.case.status.pending": "Pending",
  "admin.case.status.approved": "In progress",
  "admin.case.status.closed": "Closed",
  "admin.case.status.rejected": "Rejected",
  "admin.case.step.run": "In progress",
  "admin.case.close": "Close",
  "admin.case.closeTitle": "Close this investigation?",
  "admin.case.closeBody": "Closing ends every access grant from this case. It is logged.",
  "admin.case.closed": "Investigation closed.",
  "admin.case.new": "New investigation",
  "admin.case.dlgTitle": "Create an investigation",
  "admin.case.title": "Title",
  "admin.case.titlePh": "e.g. Suspected outbound transfer",
  "admin.case.pick": "People",
  "admin.case.from": "From",
  "admin.case.to": "To",
  "admin.case.desc": "Description (10+ characters)",
  "admin.case.dlgHint": "An investigation starts only after two-person approval. Re-sign-in, per-conversation grants, logging and owner notice still apply.",
  "admin.case.errTitle": "Enter a title of at least 2 characters.",
  "admin.case.errTargets": "Pick at least one person.",
  "admin.case.errPeriod": "Pick a valid period (up to 30 days).",
  "admin.case.created": "Sent investigation {id} for approval.",
  "admin.hist.q": "Which requests were handled?",
  "admin.hist.tech": "Approved · rejected · withdrawn · newest first",
  "admin.hist.sum": "{n|request was|requests were} handled.",
  "admin.hist.empty": "No requests handled yet.",
  "admin.hist.emptyNot": "Approvals and rejections collect here.",
  "admin.sa.edit": "Edit service account",
  "admin.sa.updated": "Updated service account “{name}”",
  "admin.sa.ownerSearch": "Find an owner",
  "admin.sa.tokenNeeded": "A new dedicated token is required",
  "admin.sa.ownerBlocked": "Assign a new owner before resuming",
  "admin.sa.updateNote": "Changing the owner or expiry revokes existing tokens. Resume suspended accounts and issue a new token.",
  "admin.act.sa.update": "Service account updated",
  "admin.sa.q": "Which non-human accounts exist?",
  "admin.sa.tech": "Service accounts · owner · purpose · expiry · dedicated token",
  "admin.sa.sum": "{n|service account|service accounts}; the next expiry is {date}.",
  "admin.sa.col.name": "Name",
  "admin.sa.col.purpose": "Purpose",
  "admin.sa.col.owner": "Owner",
  "admin.sa.col.expires": "Expires",
  "admin.sa.col.token": "Token",
  "admin.sa.col.last": "Last used",
  "admin.sa.col.status": "Status",
  "admin.sa.new": "New service account",
  "admin.sa.reissue": "Reissue token",
  "admin.sa.suspend": "Suspend",
  "admin.sa.resume": "Resume",
  "admin.sa.status.active": "Active",
  "admin.sa.status.suspended": "Suspended",
  "admin.sa.note.1": "No sign-in. The dedicated token only calls the company gateway (no read access).",
  "admin.sa.note.2": "Usage shows to the owner as “app usage”, counted as API key calls.",
  "admin.sa.note.3": "Not a person, so no consent. The per-app text policy applies (default: basic info only).",
  "admin.sa.note.4": "An expiry is required. If the owner leaves or is suspended, it stops until a new owner is set.",
  "admin.sa.readonly": "Only company-wide admins create and edit service accounts.",
  "admin.sa.dlgTitle": "New service account",
  "admin.sa.name": "Name (lowercase letters, digits, hyphens)",
  "admin.sa.purpose": "Purpose",
  "admin.sa.purposePh": "e.g. Nightly quality-check batch",
  "admin.sa.owner": "Owner",
  "admin.sa.expires": "Expiry (within a year)",
  "admin.sa.create": "Create and get token",
  "admin.sa.errName": "Use 3–32 lowercase letters, digits or hyphens.",
  "admin.sa.errDup": "A service account with this name exists.",
  "admin.sa.errPurpose": "Enter a purpose.",
  "admin.sa.errExp": "Pick an expiry between tomorrow and one year from now.",
  "admin.sa.tokenTitle": "The token is shown only once",
  "admin.sa.tokenBody": "Copy it into the app’s secret store. You can’t see it again after closing. It is a mockup value, not a real token.",
  "admin.sa.created": "Created the service account “{name}”",
  "admin.sa.reissueTitle": "Reissue the token?",
  "admin.sa.reissueBody": "The current token is revoked right away. Update the app with the new token.",
  "admin.sa.reissued": "Issued a new token and revoked the old one",
  "admin.sa.suspended": "Suspended “{name}”",
  "admin.sa.resumed": "Resumed “{name}”",
  "admin.sa.empty": "No service accounts to show.",
  "admin.sa.emptyNot": "In-house apps and CI need a service account to call the gateway.",
  // SCR-11 roles & permissions — wording the API contract needs beyond the mockup (admin.rp.*)
  "admin.rp.pseudo": "User #{code}",
  "admin.rp.system": "System",
  "admin.rp.unit.items": "",
  "admin.rp.unit.days": "days",
  "admin.rp.unit.min": "min",
  "admin.rp.unit.people": "",
  "admin.rp.err.generic": "Couldn’t complete that. Try again in a moment.",
  "admin.rp.err.forbidden": "You don’t have permission for this. Ask an admin if you need it.",
  "admin.rp.err.notFound": "Couldn’t find it. Reload and check again.",
  "admin.rp.err.stale": "Someone changed it first. Check the reloaded values and save again.",
  "admin.rp.err.network": "Couldn’t reach the server. Check the connection and try again.",
  "admin.rp.err.validation": "Check the values you entered.",
  "admin.rp.err.reauth": "Confirm your sign-in again to make this change.",
  "admin.rp.err.mfa": "This needs multi-factor authentication (MFA). Use My records → Profile, alerts & display → [Set up MFA], then try again.",
  "admin.rp.err.pledge": "This needs the prohibited-use pledge first. Refresh the page, complete the pledge, then try again.",
  "admin.rp.err.roleInUse": "Someone holds this role or a request is waiting, so it can’t be deleted.",
  "admin.rp.err.approvalPending": "A request is already waiting for approval. Handle it in Pending approvals first.",
  "admin.rp.err.noticeChanged": "The draft changed in the meantime. Check the reloaded draft and publish again.",
  "admin.rp.err.processed": "This request was already handled.",
  "admin.rp.undoExpired": "The time to undo has passed.",
  "admin.rp.saveFail": "Couldn’t save",
  "admin.rp.noticeDraft": "A new notice draft was created. Publish it in Recording policy › Notice.",
  "admin.rp.reauth.desc": "For security, confirm your password again. You won’t be asked again for a short while.",
  "admin.rp.reauth.confirm": "Confirm and continue",
  "admin.rp.reauth.wrong": "That password is wrong. Enter it again.",
  "admin.rp.reauth.googleNote": "After signing in again at Google, make the same change once more.",
  "admin.rp.roles.preview": "What changes",
  "admin.rp.roles.justChanged": "just changed",
  "admin.rp.roles.legendChanged": "Just changed (undo it from the notice)",
  "admin.rp.roles.edit": "Edit name & description",
  "admin.rp.roleDlg.editTitle": "Edit the role’s name and description",
  "admin.rp.roleDlg.save": "Save",
  "admin.rp.roleDlg.saved": "Updated the “{name}” role",
  "admin.rp.grant.count": "{n|person|people} · {m} selectable",
  "admin.rp.grant.scope": "Outside your scope",
  "admin.rp.grants.scopeNo": "Outside your scope",
  "admin.rp.grants.teamsBtn": "Managed teams",
  "admin.rp.grants.teamsTitle": "{who} · teams to manage",
  "admin.rp.grants.teamsHint": "Selected teams add this manager and removed teams revoke the assignment. Additions request independent approval for each team. Applied changes and pending approvals are reported separately.",
  "admin.rp.grants.teamsSaved": "Updated the managed teams",
  "admin.rp.apr.approveReason": "Reason for approving",
  "admin.rp.apr.expired": "Expired",
  "admin.rp.apr.targetDefer": "Delay the owner notice of investigation {id}",
  "admin.rp.case.defer": "Delay owner notice",
  "admin.rp.case.deferTitle": "Delay the owner notice?",
  "admin.rp.case.deferUntil": "Until",
  "admin.rp.case.deferReason": "Reason (10+ characters)",
  "admin.rp.case.deferHint": "Only when telling them could hinder the investigation. It needs two-person approval and lasts at most {n|day|days}; the notice shows automatically afterwards.",
  "admin.rp.case.deferErrDate": "Pick a date from tomorrow up to {n|day|days} ahead.",
  "admin.rp.case.deferSent": "Sent the notice delay for approval ({id}).",
  "admin.rp.case.notifyUntil": "Delayed until {date}",
  "admin.rp.sa.tokenOnce": "Copy it into the app’s secret store. You can’t see it again after closing.",
  "admin.rp.sa.expired": "Expired",
  "admin.rp.review.q": "Should these people keep text, real-name and export access?",
  "admin.rp.review.tech": "Quarterly review · {quarter} · flags access unused for 90 days",
  "admin.rp.review.sum": "{n|grant|grants} to review; {d} unused for 90 days.",
  "admin.rp.review.sumDone": "This quarter’s review was submitted on {date}. You can submit again if something changed.",
  "admin.rp.review.col.keys": "Access",
  "admin.rp.review.col.last": "Last used",
  "admin.rp.review.col.decision": "Decision",
  "admin.rp.review.keep": "Keep",
  "admin.rp.review.revoke": "Remove",
  "admin.rp.review.dormant": "Unused 90 days",
  "admin.rp.review.never": "Never used",
  "admin.rp.review.note": "Note (optional)",
  "admin.rp.review.submit": "Submit the review",
  "admin.rp.review.confirmTitle": "Submit the review?",
  "admin.rp.review.confirmBody": "Keep {k} · remove {r}. Removed people sign in again, and the result is logged.",
  "admin.rp.review.done": "Review submitted.",
  "admin.rp.review.empty": "Nothing to review.",
  "admin.rp.review.emptyNot": "Grants with text, real-name or export access appear here.",
  "admin.pol.desc": "Policy version {v} · saved {date} by {who} · notice {nv}",
  "admin.pol.tabs": "Recording policy views",
  "admin.pol.tab.ceiling": "Recording ceiling",
  "admin.pol.tab.notice": "Notice",
  "admin.pol.tab.redaction": "Masking rules",
  "admin.pol.tab.retention": "Retention",
  "admin.pol.tab.access": "Access controls",
  "admin.pol.tab.deletion": "Deletion & legal hold",
  "admin.pol.kpi.cap": "Company recording ceiling",
  "admin.pol.kpi.capHint": "Kept = ceiling ∩ each person’s choice",
  "admin.pol.kpi.capCustom": "Custom",
  "admin.pol.kpi.notice": "Notice",
  "admin.pol.kpi.noticeHint": "{n|person|people} yet to re-consent",
  "admin.pol.kpi.content": "Text retention",
  "admin.pol.kpi.contentHint": "Choose {min}–{max} days",
  "admin.pol.kpi.grant": "Access grant",
  "admin.pol.kpi.grantHint": "Always on · per conversation",
  "admin.pol.dirty": "{n|unsaved change|unsaved changes}",
  "admin.pol.revert": "Revert",
  "admin.pol.save": "Save",
  "admin.pol.noChange": "Nothing has changed",
  "admin.pol.saveTitle": "Save the policy?",
  "admin.pol.saveKicker": "Policy version {v} → {v2}",
  "admin.pol.saveList": "Changes",
  "admin.pol.saveNotice": "Notice section {secs} changes, so draft {ver} appears. Publishing asks everyone to consent again.",
  "admin.pol.saveReason": "Why (optional)",
  "admin.pol.saveLog": "Each changed value is recorded in the access & change log.",
  "admin.pol.saved": "Policy saved (version {v}).",
  "admin.cap.q": "How much does the company allow to be kept?",
  "admin.cap.tech": "Company recording ceiling · 6 item switches + 4-step presets",
  "admin.cap.sum": "The ceiling is {level}; all {n} people chose within it.",
  "admin.cap.sumCut": "At {level}, {n|person’s|people’s} recording level is lowered to fit.",
  "admin.cap.presets": "4-step presets",
  "admin.cap.items": "Ceiling per item",
  "admin.cap.custom": "Items differ from the presets (custom).",
  "admin.cap.basicLock": "Basic info can’t be turned off (company key terms · required processing).",
  "admin.cap.toolWarn": "Tool output contains parts of file contents and command output. Masking isn’t perfect, so turn it on only when needed.",
  "admin.cap.helperOff": "The PC helper (optional module) is off, so this can’t be chosen.",
  "admin.cap.item.basic": "Time, tool, AI model, usage, duration, success",
  "admin.cap.item.prompt": "The question text",
  "admin.cap.item.answer": "AI answer text (Codex: unofficial setting)",
  "admin.cap.item.work_detail": "Commands, file paths, changes",
  "admin.cap.item.tool_output": "Parts of file contents and command output (custom only)",
  "admin.cap.item.server_upload": "Send what the PC helper collected to the company server",
  "admin.cap.dist": "Recording levels people chose",
  "admin.cap.distCut": "{n|person is|people are} lowered to the ceiling",
  "admin.cap.rule": "What is kept is the overlap of the ceiling and each person’s choice. Lowering applies right away; raising it again restores what each person chose.",
  "admin.cap.notice": "Changing the ceiling changes notice section 2 (items).",
  "admin.notice.q": "Does the notice match the current settings?",
  "admin.notice.tech": "Notice {v} · 10 required sections · 5 filled from settings",
  "admin.notice.sumSame": "Published {v} matches the settings. {n|person is|people are} yet to re-consent.",
  "admin.notice.sumDiff": "The notice and the settings differ: section {secs} changed. Publish {ver}.",
  "admin.notice.diffTitle": "The notice and the settings differ",
  "admin.notice.diffDesc": "Check the changed sections and publish a new version. Until then people see the old notice.",
  "admin.notice.publish": "Publish new version",
  "admin.notice.publishNo": "Nothing changed, so no new version is needed",
  "admin.notice.pubTitle": "Publish {ver}?",
  "admin.notice.pubBody": "Publishing asks everyone to consent again. Records before re-consent aren’t stored (only counted). Announce the time in advance.",
  "admin.notice.published": "Published {ver}. Everyone was asked to consent again.",
  "admin.notice.auto": "Auto: {src}",
  "admin.notice.autoRo": "Filled from settings automatically, so it can’t be edited here",
  "admin.notice.changed": "Changed",
  "admin.notice.edited": "Edited draft",
  "admin.notice.editedTitle": "There are unpublished edits",
  "admin.notice.editedDesc": "Check the preview, then publish a new version. Until then people see the current notice.",
  "admin.notice.sumEdit": "Edited section {secs} isn’t published yet. Publishing {ver} asks everyone to consent again.",
  "admin.notice.pcOnly": "Edit the notice text on a PC. Here you can only read it.",
  "admin.ned.edit": "Edit",
  "admin.ned.editAria": "Edit {sec}",
  "admin.ned.kicker": "Notice draft · {ver}",
  "admin.ned.tabs": "Notice editing steps",
  "admin.ned.tab.edit": "Edit",
  "admin.ned.tab.preview": "Preview",
  "admin.ned.label": "{sec} text",
  "admin.ned.hint": "Write **text** for bold and start a line with - for a list. HTML isn’t allowed.",
  "admin.ned.lang": "You’re editing the English notice. Switch the screen language to edit the Korean one.",
  "admin.ned.preview": "This is how it looks in the notice people agree to.",
  "admin.ned.save": "Add to draft",
  "admin.ned.reset": "Back to the published text",
  "admin.ned.errEmpty": "The text can’t be empty.",
  "admin.ned.errHtml": "HTML tags aren’t allowed. Use only bold (**) and lists (-).",
  "admin.ned.saved": "Added {sec} to the draft. Publish a new version for people to see it.",
  "admin.ned.same": "It matches the published text, so it was taken out of the draft.",
  "admin.notice.src.caps": "ceiling",
  "admin.notice.src.retention": "retention table",
  "admin.notice.src.roles": "permission table",
  "admin.notice.src.redaction": "masking rules",
  "admin.notice.src.integrations": "integrations",
  "admin.notice.versions.q": "Which versions were published?",
  "admin.notice.versions.tech": "Notice versions · text hash · re-consent",
  "admin.notice.versions.sum": "The current version is {v} (published {date}).",
  "admin.notice.current": "Current",
  "admin.notice.col.ver": "Version",
  "admin.notice.col.at": "Published",
  "admin.notice.col.hash": "Text hash",
  "admin.notice.col.changes": "What changed",
  "admin.notice.first": "First version",
  "admin.notice.changesAuto": "Updated section {secs}.",
  "admin.ns.1": "1. Purpose",
  "admin.ns.2": "2. Items",
  "admin.ns.3": "3. What is never recorded",
  "admin.ns.4": "4. Retention",
  "admin.ns.5": "5. Who can view",
  "admin.ns.6": "6. Right to refuse",
  "admin.ns.7": "7. Masking limits",
  "admin.ns.8": "8. Transfer to overseas AI companies",
  "admin.ns.9": "9. Exercising your rights",
  "admin.ns.10": "10. Privacy officer & contact",
  "admin.ns.1.body": "We record AI use to manage usage and cost and to investigate security incidents. It is never used to evaluate work hours or performance, or to monitor people.",
  "admin.ns.2.req": "Required: basic info (company key terms)",
  "admin.ns.2.opt": "Optional consent: {items}",
  "admin.ns.2.off": "Off at the company ceiling: {items}",
  "admin.ns.3.body": "We never keep the AI’s intermediate thinking, full request bodies (except raw mode), keystrokes, screens or network traffic.",
  "admin.ns.4.backup": "Backups keep data for up to 30 days.",
  "admin.ns.5.content": "Question & answer text: {roles} — after a reason, re-sign-in and a per-conversation grant",
  "admin.ns.5.identity": "Real names: {roles}",
  "admin.ns.5.individual": "Individual details: {roles} — each view is logged and shown to the person",
  "admin.ns.5.none": "None",
  "admin.ns.6.body": "Refusing or withdrawing doesn’t stop you using CLI tools, but you can’t use the company-key gateway.",
  "admin.ns.7.body": "Masking only finds known patterns, so it isn’t perfect. Current {n} rules: {rules}",
  "admin.ns.8.on": "Calls through the company gateway are forwarded to overseas AI companies (Anthropic, OpenAI).",
  "admin.ns.8.off": "The company gateway isn’t used, so nothing is forwarded overseas.",
  "admin.ns.9.body": "In My records & settings you can view, copy, delete, pause or withdraw. Deletion requests are handled within 7 days.",
  "admin.ns.10.body": "Privacy officer {name} ({title}) · privacy@example.com",
  "admin.red.q": "How are secrets and personal data in text masked?",
  "admin.red.tech": "Masking rules · just before storing · 3 methods (delete · consistent token · marker)",
  "admin.red.sum": "All {n} rules are on. Resident registration numbers are deleted irreversibly.",
  "admin.red.col.rule": "Category",
  "admin.red.col.finds": "Looks for (examples)",
  "admin.red.col.method": "Method",
  "admin.red.col.fields": "Applies to",
  "admin.red.m.delete": "Delete (irreversible)",
  "admin.red.m.consistent": "Consistent token (per conversation)",
  "admin.red.m.marker": "Marker",
  "admin.red.m.omit": "Omission marker",
  "admin.red.m.nostore": "Content not stored",
  "admin.red.ms.consistent": "Consistent token",
  "admin.red.ms.marker": "Marker",
  "admin.red.fixed": "Fixed",
  "admin.red.r.secret": "Secret keys & auth tokens",
  "admin.red.r.secret.ex": "Private key blocks, JWTs, Authorization values, AI company, cloud and Git token prefixes, this system’s connection token prefixes",
  "admin.red.r.assign": "Secret assignments",
  "admin.red.r.assign.ex": "Assignments like password=, secret=, api_key= (8+ chars), passwords in DB connection strings",
  "admin.red.r.rrn": "Resident registration numbers",
  "admin.red.r.rrn.ex": "Numbers with a valid checksum",
  "admin.red.r.contact": "Contact details",
  "admin.red.r.contact.ex": "Mobile and landline numbers, email",
  "admin.red.r.finance": "Cards & accounts",
  "admin.red.r.finance.ex": "Card numbers (Luhn check), account numbers",
  "admin.red.r.blob": "Long blobs",
  "admin.red.r.blob.ex": "Long base64, data URIs",
  "admin.red.r.paths": "Secret file paths",
  "admin.red.fields.text": "Questions, answers, tool arguments, tool output, error messages, list titles",
  "admin.red.fields.paths": "Tool input and output, file lists",
  "admin.red.methodNote": "Whether contacts and cards use consistent tokens or markers is decided with the privacy owner.",
  "admin.red.order": "Order: token check → allow list → consent gate → secret paths → masking → length cap → encryption → dedup",
  "admin.red.limit": "Masking only finds known patterns, so it isn’t perfect.",
  "admin.red.paths": "When these paths appear, content isn’t stored regardless of level — only counts",
  "admin.red.pv.q": "Preview: this text is stored like this",
  "admin.red.pv.label": "Text to try (use fake values)",
  "admin.red.pv.sample": "The deploy key is sk-ant-demo-7f3a9c21e4b0. Contact dev.lead@example.com or 010-0000-1234. Once checked, reply to dev.lead@example.com.", // secret-scan:allow — fake key (demo) for the redaction preview
  "admin.red.pv.out": "As stored",
  "admin.red.pv.count": "{n|place|places} masked",
  "admin.red.pv.none": "Nothing to mask was found.",
  "admin.red.del": "deleted",
  "admin.red.omitTag": "omitted",
  "admin.ret.q": "How long are records kept?",
  "admin.ret.tech": "Default, minimum and maximum per item · nothing below the minimum",
  "admin.ret.sum": "Text is deleted after {c}, usage and basic info after {u}.",
  "admin.ret.col.target": "Item",
  "admin.ret.col.value": "Current",
  "admin.ret.col.def": "Default",
  "admin.ret.col.range": "Min–max",
  "admin.ret.col.after": "After that",
  "admin.ret.fixed": "Fixed",
  "admin.ret.upto": "Up to {v}",
  "admin.ret.atLeast": "{v} or more",
  "admin.ret.belowMin": "Below the minimum",
  "admin.ret.notice": "Changing retention changes notice section 4 (retention).",
  "admin.ret.t.content": "Question & answer text, work details",
  "admin.ret.t.raw_gateway": "Raw-mode bodies & gateway text",
  "admin.ret.t.usage": "Usage & basic info",
  "admin.ret.t.aggregate": "De-identified team aggregates",
  "admin.ret.t.consent": "Consent history & notice versions",
  "admin.ret.t.audit_permission": "Access & change log: permission changes",
  "admin.ret.t.audit_access": "Access & change log: access records",
  "admin.ret.t.audit_general": "Access & change log: general operations",
  "admin.ret.t.backup": "DB backups",
  "admin.ret.a.content": "Text is deleted and shown as “No record · deleted after retention”",
  "admin.ret.a.deleted": "Deleted",
  "admin.ret.a.usage": "Deleted; only de-identified aggregates remain",
  "admin.ret.a.consent": "Related data retention + dispute period",
  "admin.ret.a.audit": "Deleted after leaving a checkpoint",
  "admin.ret.a.backup": "Deleted; the notice says backups keep up to 30 days",
  "admin.job.q": "Is the retention cleanup running well?",
  "admin.job.tech": "Once a day · 1,000 rows at a time so intake isn’t blocked · skips legal holds",
  "admin.job.sum": "The last run was {rel}.",
  "admin.job.sumNone": "No runs yet.",
  "admin.job.run": "Run now",
  "admin.job.ran": "Cleanup ran. Nothing new to delete (0).",
  "admin.job.ranDetail": "Run now · 0 new texts to delete",
  "admin.job.noPerm": "Needs the retention job permission",
  "admin.acc.q": "What does opening someone else’s text require?",
  "admin.acc.tech": "Fixed access flow · 7 steps · can’t be turned off",
  "admin.acc.sum": "A grant covers one conversation for {m} min, reasons need {c}+ characters, and re-sign-in stays valid for {r} min.",
  "admin.acc.noOff": "This flow has no off switch — not even by company policy. Only values change, within fixed ranges.",
  "admin.acc.s1": "Check permission, pledge and MFA",
  "admin.acc.s2": "Reason category + description",
  "admin.acc.s3": "Re-sign-in",
  "admin.acc.s4": "Per-conversation grant",
  "admin.acc.s5": "View (watermark, no cache)",
  "admin.acc.s6": "Log success and denial",
  "admin.acc.s7": "Shown in the owner’s “Who viewed my records”",
  "admin.acc.fixed": "Always on",
  "admin.acc.value": "Value only",
  "admin.acc.v.grant": "Grant length",
  "admin.acc.v.grantHint": "10–60 min · default 60",
  "admin.acc.v.reason": "Minimum reason length",
  "admin.acc.v.reasonHint": "Can’t go below 10",
  "admin.acc.v.reauth": "Re-sign-in stays valid for",
  "admin.acc.v.reauthHint": "Can’t exceed 10 min",
  "admin.acc.cats": "Reason categories are fixed at 4 (no evaluation or attendance): {cats}",
  "admin.sg.q": "Are small groups shown?",
  "admin.sg.tech": "Small-group minimum · people left after filters",
  "admin.sg.sum": "Hidden below {n} people. Right now this applies to {teams}.",
  "admin.sg.sumNone": "Hidden below {n} people. No team is affected right now.",
  "admin.sg.off": "Statistics are shown even for one person. Values are not hidden by group size.",
  "admin.sg.value": "Minimum",
  "admin.sg.unit": "people",
  "admin.sg.fixed": "Set this on the server. One shows every group; two or more hides values below that number of people.",
  "admin.sg.fixedBadge": "Fixed in the settings file",
  "admin.sg.where": "Applies to home cards, hourly heatmaps, usage statistics, people and team comparisons, and exports. Access permissions and missing-record states still apply.",
  "admin.vs.q": "Can people be sorted by value?",
  "admin.vs.tech": "Allow sorting people by value · off by default",
  "admin.vs.sumOff": "Off. People are listed by name only.",
  "admin.vs.sumOn": "On. Only usage and cost metrics can be sorted by value.",
  "admin.vs.switch": "Allow sorting people by value",
  "admin.vs.desc": "Even when on, AI active time, conversation length and line counts are never ranked.",
  "admin.del.q": "How were deletion requests handled?",
  "admin.del.tech": "Blocked from view right away · handled within 7 days · legal hold first",
  "admin.del.sum": "No deletion requests waiting. {n} handled so far.",
  "admin.del.sumWait": "{n|deletion request is|deletion requests are} waiting.",
  "admin.del.emptyWhat": "No deletion requests.",
  "admin.del.emptyNot": "When one arrives it is blocked from view right away and handled here.",
  "admin.del.col.req": "Request",
  "admin.del.col.who": "Requested by",
  "admin.del.col.done": "Handled",
  "admin.del.col.state": "Result",
  "admin.del.done": "Deleted",
  "admin.del.wait": "Waiting",
  "admin.del.rule": "Text and identifiers are deleted; usage for cost settlement stays as pseudonymous aggregates. App records and the access & change log aren’t subject to self-deletion.",
  "admin.lh.q": "Any records on legal hold?",
  "admin.lh.tech": "Excluded from cleanup and deletion · set and release are shown to the person",
  "admin.lh.sum": "{n|person’s|people’s} records are on legal hold.",
  "admin.lh.sumNone": "No records are on legal hold.",
  "admin.lh.emptyNot": "Only records needed for an investigation or dispute are held, with a reason.",
  "admin.lh.until": "Until {date}",
  "admin.lh.since": "Set {date} · {who}",
  "admin.lh.release": "Release",
  "admin.lh.set": "Set legal hold",
  "admin.lh.releaseTitle": "Release the legal hold?",
  "admin.lh.releaseBody": "Releasing resumes pending cleanup and deletion requests. The release is shown to the person.",
  "admin.lh.reason": "Reason (5+ characters)",
  "admin.lh.released": "Legal hold released.",
  "admin.lh.person": "Person",
  "admin.lh.untilLabel": "Until",
  "admin.lh.errUntil": "Pick a date from tomorrow.",
  "admin.lh.done": "Legal hold set.",
  "admin.lh.noPerm": "Needs the legal hold permission",
  "admin.lh.released.tag": "Released",
  "admin.pol.hist.q": "How was the policy changed recently?",
  "admin.pol.hist.tech": "Policy changes · notice publishing · newest first",
  "admin.pol.hist.sum": "The latest change was {rel}, by {who}.",
  "admin.pol.hist.col.when": "Time",
  "admin.pol.hist.col.what": "What",
  "admin.pol.hist.col.who": "Who",
  "admin.pol.hist.col.why": "Why",
  // SCR-12 recording policy — wording the API contract needs beyond the mockup (admin.rp.*)
  "admin.rp.pol.descLimited": "Only the parts you handle are shown here. Admins set the rest.",
  "admin.rp.red.busy": "Masking…",
  "admin.rp.redact.account": "account number",
  "admin.rp.ret.aboveMax": "Longer than the maximum",
  "admin.rp.acc.defer": "Longest owner-notice delay during an investigation",
  "admin.rp.acc.bulk": "Bulk viewing alert",
  "admin.rp.acc.bulkV": "Over {n} views in an hour without an investigation",
  "admin.rp.acc.decided": "These two values are company decisions; only the current values are shown here.",
  "admin.rp.del.one": "One conversation",
  "admin.rp.del.all": "Everything",
  "admin.rp.del.stCanceled": "Canceled",
  "admin.rp.del.due": "Requests not handled within {n|day|days} are deleted automatically.",
  "admin.rp.lh.notifyUntil": "Owner notice delayed until {date}",
  "admin.rp.lh.releasedBy": "Released {date} · {who}",
  "admin.rp.job.running": "Running retention cleanup…",
  "admin.rp.job.progress": "Running retention cleanup… {done}/{total}",
  "admin.rp.job.done": "Retention cleanup finished.",
  "admin.rp.job.failed": "Retention cleanup didn’t finish. Check Collection status for the cause.",
  "admin.rp.job.later": "Retention cleanup is still running. Check the result in a moment.",
  "admin.rp.job.deleted": "{n} deleted",
  "admin.rp.job.schedule": "Daily schedule",
  "admin.rp.job.st.running": "Running",
  "admin.rp.job.st.ok": "Finished",
  "admin.rp.job.st.partial": "Partly finished",
  "admin.rp.job.st.error": "Failed",
  "admin.rp.job.st.skipped": "Skipped",
  "admin.aud.desc": "{n} entries · can’t be edited or deleted · protected by a hash chain and external anchors",
  "admin.aud.verify": "Tamper check",
  "admin.aud.report": "Monthly review report",
  "admin.aud.csv": "Export CSV",
  "admin.aud.kpi.total": "Entries in period",
  "admin.aud.kpi.views": "Text views",
  "admin.aud.kpi.viewsHint": "Succeeded {s} · denied {d}",
  "admin.aud.kpi.perm": "Permission & policy changes",
  "admin.aud.kpi.permHint": "Permission {p} · policy {q}",
  "admin.aud.kpi.integ": "Tamper check",
  "admin.aud.kpi.ok": "Intact",
  "admin.aud.kpi.bad": "Broken",
  "admin.aud.kpi.integHint": "{n} entries · anchor {date}",
  "admin.aud.bulk": "{who} opened {n} texts within an hour",
  "admin.aud.bulkCase": "Within investigation {id} · {from}–{to}",
  "admin.aud.bulkNoCase": "Opened without an investigation. Check the reasons.",
  "admin.integ.q": "Has the log been tampered with?",
  "admin.integ.tech": "Hash chain + external anchors (signed daily)",
  "admin.integ.boxOk": "Intact ✓ · the chain #1–#{n} is unbroken",
  "admin.integ.boxBad": "Mismatch · the chain can’t be trusted from #{seq}",
  "admin.integ.sumOk": "All {n} entries are intact ✓ · external anchor {date} matches",
  "admin.integ.sumBad": "First mismatch at #{seq}; {n|later entry|later entries} can’t be trusted.",
  "admin.integ.auto": "Checked automatically every day · last anchor signed {at}",
  "admin.integ.ranAt": "Checked just now · {at}",
  "admin.integ.run": "Check now",
  "admin.integ.running": "Checking…",
  "admin.integ.demo": "Secretly change one row",
  "admin.integ.demoNote": "This button doesn’t exist in the product. Entry #{seq}’s detail was changed briefly for the check and restored right away. The real log wasn’t changed.",
  "admin.integ.sumDemo": "Mockup only: the check result when #{seq} is the first mismatch; {n|later entry|later entries} can’t be trusted.",
  "admin.integ.chain": "Recent chain",
  "admin.integ.anchor": "External anchor {date} · up to #{seq}",
  "admin.integ.afterAnchor": "Today’s entries join the anchor after midnight",
  "admin.integ.noPerm": "Needs the tamper-check permission",
  "admin.integ.logged": "Checked. The check itself was logged.",
  "admin.integ.blockOk": "intact",
  "admin.integ.blockBad": "mismatch",
  "admin.grade.q": "How long are log entries kept?",
  "admin.grade.tech": "Retention grades · can’t go below the legal minimum",
  "admin.grade.sum": "Permission changes 3 years, access records 2 years, general operations 1 year.",
  "admin.grade.3y": "Permissions & accounts · 3 years",
  "admin.grade.3y.d": "Role and permission grants, changes and removals, two-person decisions, account changes",
  "admin.grade.2y": "Access records · 2 years (min 1)",
  "admin.grade.2y.d": "Text views and denials, individual views, exports, sign-ins, log views and checks",
  "admin.grade.1y": "General operations · 1 year",
  "admin.grade.1y.d": "Policy and setting changes, retention cleanup, token issue and revocation",
  "admin.audlist.q": "Who viewed or changed what, and when?",
  "admin.audlist.tech": "Access & change log · newest first · open a row to see its hash",
  "admin.audlist.sum": "{n|entry|entries} match; {d} denied or failed.",
  "admin.audlist.kinds": "Kind",
  "admin.audlist.person": "Person",
  "admin.audlist.personAll": "Everyone",
  "admin.audlist.search": "Search conversation # or detail",
  "admin.audlist.clear": "Clear filters",
  "admin.audlist.cond": "Filters",
  "admin.audlist.condTitle": "Log filters",
  "admin.audlist.condN": "Filters {n}",
  "admin.audlist.empty": "No entries match.",
  "admin.audlist.emptyNot": "No entries doesn’t always mean nothing happened. Widen the period or filters.",
  "admin.audlist.suggest": "Remove “{kind}” to see {n}",
  "admin.audlist.col.when": "Time",
  "admin.audlist.col.what": "What",
  "admin.audlist.col.who": "Who (role)",
  "admin.audlist.col.target": "Target",
  "admin.audlist.col.cat": "Reason category",
  "admin.audlist.col.result": "Result",
  "admin.audlist.conv": "Conversation #{no}",
  "admin.audlist.viewLogged": "Opening this screen is logged too.",
  "admin.k.content_ok": "Text view (succeeded)",
  "admin.k.content_denied": "Text view (denied)",
  "admin.audrow.title": "Entry #{seq}",
  "admin.audrow.time": "Time",
  "admin.audrow.action": "Action",
  "admin.audrow.actor": "Who",
  "admin.audrow.target": "Target",
  "admin.audrow.reason": "Reason",
  "admin.audrow.detail": "Detail",
  "admin.audrow.grade": "Retention",
  "admin.audrow.hash": "Hash",
  "admin.audrow.prev": "Previous hash",
  "admin.audrow.anchor": "External anchor",
  "admin.audrow.case": "Investigation",
  "admin.audrow.koOnly": "Detail recorded in Korean only",
  "admin.audrow.grade.3y": "3 years",
  "admin.audrow.grade.2y": "2 years",
  "admin.audrow.grade.1y": "1 year",
  "admin.act.login": "Sign-in",
  "admin.act.login.failed": "Sign-in failed",
  "admin.act.role.change": "Role change",
  "admin.act.role.create": "Role created",
  "admin.act.approval.request": "Approval requested",
  "admin.act.approval.approve": "Approved",
  "admin.act.approval.reject": "Rejected",
  "admin.act.approval.withdraw": "Request withdrawn",
  "admin.act.case.approve": "Investigation approved",
  "admin.act.case.close": "Investigation closed",
  "admin.act.policy.change": "Policy change",
  "admin.act.notice.publish": "Notice published",
  "admin.act.content.view": "Text view",
  "admin.act.content.grant": "Conversation access grant",
  "admin.act.person.view": "Individual view",
  "admin.act.export": "Export",
  "admin.act.consent.change": "Consent change",
  "admin.act.connection.add": "Tool connected",
  "admin.act.deletion.request": "Deletion request",
  "admin.act.deletion.process": "Deletion processed",
  "admin.act.deletion.cancel": "Deletion request cancelled",
  "admin.act.retention.run": "Retention cleanup",
  "admin.act.legal_hold.set": "Legal hold set",
  "admin.act.legal_hold.release": "Legal hold released",
  "admin.act.apikey.rotate": "API key rotation",
  "admin.act.key.rotate": "Encryption key rotation",
  "admin.act.token.revoke": "Token revoked",
  "admin.act.sa.create": "Service account created",
  "admin.act.sa.token": "Service account token reissued",
  "admin.act.sa.suspend": "Service account suspended or resumed",
  "admin.act.audit.view": "Log viewed",
  "admin.act.audit.verify": "Tamper check",
  "admin.act.audit.review": "Monthly review result",
  "admin.act.org.sync": "Org report sync",
  "admin.act.price.version": "New price version",
  "admin.dx.applied": "{id} applied",
  "admin.dx.perm": "{role} · {perm} {sFrom} → {sTo}",
  "admin.dx.undo": "Undone",
  "admin.dx.id": "{id}",
  "admin.dx.roleOnly": "{role}",
  "admin.dx.permTo": "{perm} → {scope}",
  "admin.dx.grant": "Assigned {role}",
  "admin.dx.ungrant": "Removed {role}",
  "admin.dx.teams": "Teams: {teams}",
  "admin.dx.until": "Until {date}",
  "admin.dx.roleCreate": "{name} · copy of {role}",
  "admin.dx.roleRemoved": "Deleted role {name}",
  "admin.dx.roleRestored": "Restored role {name}",
  "admin.dx.caseReq": "{id} · {case} · {n} people",
  "admin.dx.saStatus": "{name} · {st1} → {st2}",
  "admin.dx.name": "{name}",
  "admin.dx.notice": "Notice {v1} → {v2} · changed {secs} · re-consent requested",
  "admin.dx.holdSet": "Expiry deletion on hold · until {ymd}",
  "admin.dx.holdRelease": "Released the hold set in #{seq}",
  "admin.dx.verifyOk": "{n}-entry chain · intact",
  "admin.dx.verifyBad": "{n}-entry chain · mismatch from #{seq}",
  "admin.dx.verifyAnchor": "{n}-entry chain · differs from the anchor",
  "admin.dx.anchor": "Checked against the {date} anchor",
  "admin.dx.review": "{month} monthly review · {verdict}",
  "admin.dx.csv": "Access & change log · {n} rows · CSV (pseudonymous)",
  "admin.dx.csvId": "Access & change log · {n} rows · CSV (real names)",
  "admin.dx.orgSync": "Anthropic, OpenAI",
  "admin.dx.device": "Device",
  "admin.dx.saToken": "{name} · token reissued",
  "admin.dx.price": "Price table from {date} · {n} models",
  "admin.rep.title": "Monthly review report",
  "admin.rep.kicker": "{range} · access record review",
  "admin.rep.lead": "Admins’ text views are reviewed by the log reviewer, not by admins (separation of duties).",
  "admin.rep.byViewer": "Text views by viewer",
  "admin.rep.byTarget": "Text views by person",
  "admin.rep.offHours": "Views outside work hours (before 9, after 18, weekends)",
  "admin.rep.exports": "Exports",
  "admin.rep.perms": "Permission changes",
  "admin.rep.cases": "Investigations & notice deferrals",
  "admin.rep.none": "None",
  "admin.rep.viewRow": "{who} · {n} ({d} denied)",
  "admin.rep.targetRow": "{who} · {n}",
  "admin.rep.result": "Review result",
  "admin.rep.ok": "No issues",
  "admin.rep.check": "Needs investigation",
  "admin.rep.memo": "Note (optional)",
  "admin.rep.save": "Record the result",
  "admin.rep.saved": "Review result recorded in the log.",
  "admin.rep.noPerm": "Log reviewers or admins record the result.",
  "admin.csv.title": "Export the access & change log",
  "admin.csv.kicker": "CSV · {n|row|rows}",
  "admin.csv.head": "Header preview",
  "admin.csv.identity": "Include real names",
  "admin.csv.identityOff": "No permission to export real names, so pseudonyms are used.",
  "admin.csv.rules": "Cells that could run as formulas (starting with = + - @) get a leading quote. Files aren’t kept on the server; up to 10,000 rows at a time.",
  "admin.csv.download": "Download",
  "admin.csv.done": "CSV downloaded. The export was logged.",
  "admin.csv.noPerm": "Needs the row export permission",
  "admin.csv.h.id": "Export ID",
  "admin.csv.h.by": "Exported by role",
  "admin.csv.h.range": "Period",
  "admin.csv.h.filter": "Filters",
  "admin.csv.h.ban": "Prohibited use",
  "admin.csv.h.banText": "Not for performance evaluation, attendance or monitoring",
  "admin.csv.h.limit": "Masking limits",
  "admin.sys.desc": "Last received {rel} · company-wide · as of {asof}",
  "admin.sys.kpi.today": "Received today",
  "admin.sys.kpi.todayHint": "Duplicates {d} · not stored by rule {x}",
  "admin.sys.kpi.last": "Last received",
  "admin.sys.kpi.lastHint": "Collection server · {formats}",
  "admin.sys.kpi.conn": "Connected",
  "admin.sys.kpi.connHint": "of {n} · error {p} · not connected {d} · quiet {q}",
  "admin.sys.kpi.gaps": "Collection gaps",
  "admin.sys.kpi.gapsHint": "Server {s} · device {d} · longest {m}",
  "admin.sys.c1.error": "Recent intake error · counter updated at",
  "admin.sys.c1.q": "Are CLI records reaching the server?",
  "admin.sys.c1.tech": "C1 direct to server · OTLP/HTTP logs & metrics",
  "admin.sys.c1.sum": "Received {n} today; the last one {rel}.",
  "admin.sys.c1.received": "Received today",
  "admin.sys.c1.dup": "Duplicates (counted once)",
  "admin.sys.c1.dropped": "Dropped",
  "admin.sys.c1.droppedHint": "Last 30 days: by rule {p} · forbidden {f} · invalid {i}",
  "admin.sys.c1.rejected": "Rejected (expired token)",
  "admin.sys.c1.rejectedV": "From {n|device|devices}",
  "admin.sys.c1.formats": "Formats",
  "admin.sys.c1.queue": "Intake requests in progress",
  "admin.sys.c1.loss": "With direct-to-server only, records sent while the server is down can be lost. {n|server gap|server gaps} in 30 days · {m} min in total.",
  "admin.sys.c3.q": "Are API key calls passing the gateway?",
  "admin.sys.c3.tech": "C3 API gateway · gateway token required",
  "admin.sys.c3.sum": "{n|call|calls} in this period; error rate {r}.",
  "admin.sys.c3.calls": "Calls",
  "admin.sys.c3.err": "Error rate",
  "admin.sys.c3.errV": "{r} ({e}/{n})",
  "admin.sys.c3.cli": "CLI via gateway",
  "admin.sys.c3.cliV": "{n} · checking duplicates",
  "admin.sys.c3.routes": "Allowed routes",
  "admin.sys.c3.emptyWhat": "No calls went through the gateway in this period.",
  "admin.sys.c3.emptyNot": "Only calls through the gateway show here; API keys may still have been used.",
  "admin.sys.c4.q": "Did org reports arrive on time?",
  "admin.sys.c4.tech": "C4 org usage & cost reports · daily · not per person",
  "admin.sys.c4.sumOk": "Both AI companies’ reports arrived on time.",
  "admin.sys.c4.sumWarn": "{p} needs a look.",
  "admin.sys.c4.lastSync": "Last synced {at}",
  "admin.sys.c4.keysLabel": "Key registry",
  "admin.sys.c4.keys": "{a|linked key|linked keys} · {m} added manually",
  "admin.sys.c4.period": "{d|day|days} · {k|key|keys} · {usd}",
  "admin.sys.c4.periodNone": "No org reports for this period",
  "admin.sys.c4.sync": "Sync now",
  "admin.sys.c4.syncing": "Syncing organization usage reports",
  "admin.sys.c4.synced": "Sync finished · see “Did org reports arrive on time?” in Collection status",
  "admin.sys.c4.requested": "Sync requested just now",
  "admin.sys.c4.noPerm": "Needs the integrations permission",
  "admin.sys.c4.emptyWhat": "No Admin key, so org reports weren’t received.",
  "admin.sys.c4.emptyNot": "Per-person records (CLI, gateway) still arrive; only org totals are empty.",
  "admin.sys.c4.howTo": "How to add an Admin key",
  "admin.sys.c2.q": "Is the PC helper on?",
  "admin.sys.c2.tech": "C2 PC helper · optional module (phase 2)",
  "admin.sys.c2.sum": "It is an optional module and off. {p} of {n|pilot device|pilot devices} have errors.",
  "admin.sys.c2.module": "Module",
  "admin.sys.c2.moduleV": "Shown in the connect wizard only after an admin turns it on",
  "admin.sys.c2.pilot": "Pilot devices",
  "admin.sys.c2.noResp": "Devices with errors",
  "admin.gap.q": "Were there times nothing came in?",
  "admin.gap.tech": "Collection gap band · whole server / one device · Korea time",
  "admin.gap.sum": "{s|whole-server gap|whole-server gaps} and {d|device gap|device gaps} in this period.",
  "admin.gap.sumNone": "No collection gaps in this period.",
  "admin.gap.server": "Whole-server gap",
  "admin.gap.device": "One-device gap",
  "admin.gap.alerted": "Alert sent (over 30 min)",
  "admin.gap.ongoing": "Still ongoing",
  "admin.gap.band": "Collection gap timeline",
  "admin.gap.zoomIn": "Zoom in +",
  "admin.gap.zoomOut": "Zoom out −",
  "admin.gap.zoomHint": "Select a gap or press [Zoom in +] to spread out just that gap, with an hour on each side.",
  "admin.gap.zoomed": "Zoomed in · {range}",
  "admin.gap.zoomTo": "select to zoom in on this gap",
  "admin.gap.prev": "Previous gap",
  "admin.gap.next": "Next gap",
  "admin.gap.rule": "If the server receives nothing for over 30 minutes during work hours, admins and operations are alerted. Values in that window show as “No record · server didn’t receive”.",
  "admin.gap.emptyNot": "No gaps doesn’t mean every device sent records. See device connections in Connect tools.",
  "admin.daily.q": "Were records received every day?",
  "admin.daily.tech": "Stored · not stored by rule · duplicates · Korea time",
  "admin.daily.sum": "The busiest day was {day} ({v}).",
  "admin.daily.limit": "Intake statistics cover the last 30 days only.",
  "admin.daily.stored": "Stored",
  "admin.daily.dropped": "Not stored by rule",
  "admin.daily.dup": "Duplicates",
  "admin.daily.when": "Date",
  "admin.daily.emptyWhat": "No records were received in this period.",
  "admin.daily.emptyNot": "No records doesn’t mean intake stopped; weekends and holidays are quiet.",
  "admin.drop.q": "Why were records dropped?",
  "admin.drop.tech": "Last 30 days · count by reason · values aren’t kept",
  "admin.drop.sum": "The top reason is “{r}” ({p}).",
  "admin.drop.policy": "Not stored by rule",
  "admin.drop.policy.d": "Outside consent or level",
  "admin.drop.forbidden.d": "Thinking, bodies, etc.",
  "admin.drop.invalid.d": "Malformed",
  "admin.drop.forbidden": "Forbidden items",
  "admin.drop.invalid": "Invalid format",
  "admin.unk.q": "Did unfamiliar names arrive?",
  "admin.unk.tech": "Unfamiliar event and attribute names · name and count only",
  "admin.unk.sum": "{n|unfamiliar name|unfamiliar names} arrived. Decide whether to add them to the support table.",
  "admin.ver.q": "Are new CLI versions being checked?",
  "admin.ver.tech": "Supported versions · minimum · being checked · versions in use",
  "admin.ver.sum": "Checking {tool} {ver}. Until then, text and work details carry a “being checked” badge.",
  "admin.ver.sumNone": "No new versions are being checked.",
  "admin.ver.min": "Minimum",
  "admin.ver.latest": "Latest checked",
  "admin.ver.checking": "Checking",
  "admin.ver.checked": "Last checked {date}",
  "admin.ver.inUse": "Versions in use",
  "admin.ver.conn": "{v} · {n|connection|connections}",
  "admin.hl.q": "Is the server healthy?",
  "admin.hl.tech": "3 run units · storage · keys & backups",
  "admin.hl.sum": "All 3 run units are working. {p} of storage is used.",
  "admin.hl.collector": "Collection server",
  "admin.hl.collectorV": "Last received {rel}",
  "admin.hl.api": "Web API",
  "admin.hl.apiV": "Just served this screen",
  "admin.hl.worker": "Batch worker",
  "admin.hl.workerV": "Retention cleanup {a} · org report sync {b}",
  "admin.hl.sumUnknown": "The run units are responding, but disk usage is unavailable.",
  "admin.hl.sumUnknownWarn": "Check {n} run units. Disk usage is unavailable.",
  "admin.hl.volume": "Server disk usage",
  "admin.sys.pathPending": "This collection path is awaiting integration and verification.",
  "admin.hl.storage": "Storage",
  "admin.hl.storageV": "{used} of {total}",
  "admin.hl.keys": "Encryption keys",
  "admin.hl.keysV": "Last rotated {date}",
  "admin.hl.backup": "DB backups",
  "admin.hl.backupV": "Kept up to 30 days · encryption keys are stored separately",
  "admin.cost.desc": "Price table {v} · the 4 cost kinds are never added together",
  "admin.cost.toStats": "See costs in Insights",
  "admin.kinds.q": "What kinds of cost are there?",
  "admin.kinds.tech": "4 cost kinds · calculated differently, never added",
  "admin.kinds.sum": "For these filters: CLI tool estimate {a} · unofficial {b} · price-table cost {c} · org billing {d} (never added together).",
  "admin.kinds.why": "The same call can appear in two sources (e.g. CLI via the gateway), and prices, discounts and rounding differ, so a sum would be wrong.",
  "admin.kinds.src": "Source",
  "admin.kinds.how": "How",
  "admin.kinds.basis": "{n|conversation|conversations}",
  "admin.kinds.basisOrg": "{k|key|keys} · {d|day|days}",
  "admin.kind.cli": "CLI tool estimate",
  "admin.kind.cli.src": "cost_usd sent by Claude Code",
  "admin.kind.cli.how": "Calculated by the tool with its own prices.",
  "admin.kind.cli.tag": "Estimate · not a bill",
  "admin.kind.unofficial": "Unofficial (Codex)",
  "admin.kind.unofficial.src": "Codex turn_cost (unofficial)",
  "admin.kind.unofficial.how": "Not in the official docs, so it may not arrive.",
  "admin.kind.unofficial.tag": "Unofficial · not a bill",
  "admin.kind.gateway": "Price-table cost",
  "admin.kind.gateway.src": "Gateway usage × the price table below",
  "admin.kind.gateway.how": "Calculated with the price version in effect that day.",
  "admin.kind.gateway.tag": "Calculated · not a bill",
  "admin.kind.org": "Org billing",
  "admin.kind.org.src": "AI company org reports (daily)",
  "admin.kind.org.how": "Billing-basis amounts from the AI company; can’t be split per person.",
  "admin.kind.org.tag": "Billing basis · not per person",
  "admin.price.q": "Which prices are used?",
  "admin.price.tech": "Price table · price versions · USD per 1M tokens · sample values",
  "admin.price.sum": "Version {v} is in effect; {n|price changed|prices changed} from the previous version.",
  "admin.price.sumFirst": "Version {v} is in effect.",
  "admin.price.ver": "Price version",
  "admin.price.verCur": "{v} (current)",
  "admin.price.verNext": "{v} (scheduled)",
  "admin.price.verOld": "{v} (past)",
  "admin.price.range": "In effect from {from}",
  "admin.price.rangeTo": "In effect {from} – {to}",
  "admin.price.col.provider": "AI company",
  "admin.price.col.model": "AI model",
  "admin.price.unit": "Unit: USD per 1M tokens",
  "admin.price.changed": "Differs from the previous version",
  "admin.price.new": "New price version",
  "admin.price.rule1": "New prices apply from the start date; past calculations keep the version in effect then.",
  "admin.price.rule2": "Calls with models missing from the table get a “Not in the price table, so no cost” badge.",
  "admin.price.rule3": "Model names and prices are sample values for the mockup.",
  "admin.price.dlgTitle": "New price version",
  "admin.price.from": "Start date",
  "admin.price.fromHint": "Only dates from tomorrow.",
  "admin.price.copyNote": "Current values are copied in; change only what you need.",
  "admin.price.save": "Schedule",
  "admin.price.saved": "Scheduled price version {v}.",
  "admin.price.errNum": "Prices must be numbers from 0 to 1,000.",
  "admin.price.errDate": "Pick a start date from tomorrow.",
  "admin.price.errDup": "A price version for that date exists.",
  "admin.bud.q": "Can teams have budgets and limits?",
  "admin.bud.tech": "Budgets & limits · optional module",
  "admin.bud.badge": "Phase 2",
  "admin.bud.sum": "An optional module that isn’t on yet. When on, it sets monthly team limits and 90% alerts.",
  "admin.bud.col.team": "Team",
  "admin.bud.col.month": "This month (price table)",
  "admin.bud.col.limit": "Monthly limit",
  "admin.bud.noLimit": "Not set",
  "admin.bud.small": "Small teams combined",
  "admin.roles.bundleCount": "{n} of {total} permissions in this group",
  "admin.bud.smallSub": "{t|team|teams} · {n} people (teams under 3)",
  "admin.bud.rule": "Alerts at 90%; blocking at 100% is optional (gateway only).",
  "admin.bud.enable": "Turn on budgets",
  "admin.bud.enableNo": "Phase 2 optional module — can’t be turned on yet",
  "admin.bud.monthNote": "Price-table cost · not a bill · {range}",
  "admin.bud.smallHidden": "Teams under 3 · still under 3 combined, so values are hidden",
  "admin.pol.descOps": "Operators only handle deletion requests here. Admins set the rest of the policy.",
  "admin.del.col.scope": "What",
  "admin.del.col.when": "Requested",
  "admin.del.col.due": "Auto-delete",
  "admin.del.col.act": "Handle",
  "admin.del.records": "{n|conversation|conversations}",
  "admin.del.auto": "Auto, from consent withdrawal",
  "admin.del.st.pending": "Waiting",
  "admin.del.st.done": "Deleted",
  "admin.del.st.held": "On hold (legal hold)",
  "admin.del.st.rejected": "Rejected",
  "admin.del.by": "{who} · {when}",
  "admin.del.do.delete": "Delete",
  "admin.del.do.hold": "Hold",
  "admin.del.do.reject": "Reject",
  "admin.del.dlg.delete": "Delete this request’s records?",
  "admin.del.dlg.hold": "Put on hold for legal hold?",
  "admin.del.dlg.reject": "Reject this request?",
  "admin.del.lead.delete": "Text and identifiers in {who}’s {what} ({n}) are deleted. Usage for cost settlement stays as pseudonymous aggregates. The result is shown to them.",
  "admin.del.lead.hold": "These records are on legal hold, so they’re held instead of deleted. Viewing stays blocked, and the request is handled again when the hold ends. The note is shown to them.",
  "admin.del.lead.reject": "Rejecting lifts the viewing block and the records show again. The reason is shown to them.",
  "admin.del.memo": "Note (shown to the person)",
  "admin.del.memoReq": "Write a note of at least 5 characters.",
  "admin.del.memoHint": "Hold and reject need a note. Delete doesn’t.",
  "admin.del.holdOnly": "On legal hold, so it can’t be deleted — put it on hold",
  "admin.del.toast.delete": "Deleted · the result is shown to the person",
  "admin.del.toast.hold": "Put on hold · viewing stays blocked",
  "admin.del.toast.reject": "Rejected · the records show again",
  "admin.del.blockNote": "Even before handling, requested records are already out of every role’s lists, details and totals (viewing blocked).",
  "admin.sys.c1.queueV": "{n} in progress · oldest request {s} s",
  "admin.sys.c1.queueHint": "Up to {limit} concurrent requests · as of {rel}",
  "admin.ver.legacy": "Devices with old PoC settings",
  "admin.ver.legacyV": "{n|device|devices}",
  "admin.ver.legacyHint": "Records may also go to the old test server. Cleanup steps show on each person’s Connect page.",
  "admin.hl.byKind": "By type",
  "admin.hl.kind.content": "Question & answer text, work details",
  "admin.hl.kind.usage": "Usage & basic info",
  "admin.hl.kind.audit": "Access & change log",
  "admin.hl.kind.other": "Other (settings, glossary, cache)",
  "admin.hl.backupLast": "Last backup {at} · {size} · kept up to 30 days",
  "admin.hl.keyBackup": "Key backup",
  "admin.hl.keyBackupV": "Last {at} · key {v} · stored apart from backups",
};

export default admin;
